import {MultiSelect, TableSearchInput} from '@/components';
import {Select} from '@/components/common/Input';
import {useCountryList} from '@/context/CountryListContext';
import {useProcessorOptions} from '@/hooks/useProcessorOptions';
import {mapCountryCodeToFlags} from '@/utils/countries';

import type {BankFilterState, ProcessorFilterValue} from './types';
import {ANY_PROCESSOR, NOT_MAPPED} from './types';

type BankFiltersProps = {
  filters: BankFilterState;
  onCountryCodesChange: (codes: string[]) => void;
  onProcessorFilterChange: (value: ProcessorFilterValue) => void;
  onSearchChange: (value: string) => void;
};

const BankFilters = ({
  filters,
  onCountryCodesChange,
  onProcessorFilterChange,
  onSearchChange,
}: BankFiltersProps) => {
  const {
    state: {countryList},
  } = useCountryList();
  const {processorOptions} = useProcessorOptions();

  const flags = mapCountryCodeToFlags(countryList ?? []);
  const countryOptions = (countryList ?? []).map((country) => ({
    value: country.iso2,
    key: country.iso2,
    label:
      `${flags[country.iso2] ?? ''} ${country.name} (${country.iso2})`.trim(),
  }));

  return (
    <div className="mt-5 w-full grid grid-cols-1 md:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)] gap-3 items-center">
      <MultiSelect
        id="bank-countries"
        name="countries"
        options={countryOptions}
        value={filters.countryCodes.join(',')}
        onChange={(value) =>
          onCountryCodesChange(value ? value.split(',') : [])
        }
        placeholder="Pick one or more countries"
      />
      <Select
        name="processor"
        aria-label="Processor"
        value={filters.processorFilter}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          onProcessorFilterChange(e.target.value as ProcessorFilterValue)
        }
        options={[
          {key: 'Any processor', value: ANY_PROCESSOR},
          {key: 'Not mapped to any processor', value: NOT_MAPPED},
          ...processorOptions,
        ]}
      />
      <TableSearchInput
        value={filters.search}
        onChange={onSearchChange}
        placeholder="Search by bank name or code"
      />
    </div>
  );
};

export default BankFilters;
